<template>
  <div>
    <new-group :toggle="show_new_group" @created="retrieve" />
    <view-group
      :toggle="show_view_group"
      :group_id="view_group_id"
      @updated="retrieve"
    />
    <v-row>
      <errors-messages :errors="errors" />
      <v-col>
        <v-btn color="primary" @click="show_new_group = !show_new_group">
          <v-icon class="mr-1">mdi-plus</v-icon>
          NOVO GRUPO
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          dense
          locale="pt-BR"
          no-data-text="Nenhuma grupo cadastrado"
          no-results-text="Nenhuma grupo coincide com os filtros"
          :loading="loading"
          :headers="headers"
          :items="groups"
          @click:row="openViewModal"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import NewGroup from "./NewGroup.vue";
import ViewGroup from "./ViewGroup.vue";

export default {
  components: {
    ErrorsMessages,
    NewGroup,
    ViewGroup,
  },
  name: "Groups",
  data: () => ({
    errors: [],
    loading: false,

    headers: [
      { text: "Código", value: "id" },
      { text: "Nome", value: "name" },
      { text: "Permissões", value: "permissions" },
    ],
    groups: [],

    show_new_group: false,

    show_view_group: false,
    view_group_id: "",
  }),
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      this.loading = true;

      try {
        const response = await api.get(
          "/admin/rest-home/default/permission/groups"
        );
        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.groups = groups;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async openViewModal(item) {
      this.view_group_id = item.id;
      this.show_view_group = !this.show_view_group;
    },
  },
};
</script>

<style>
</style>